import ApiService from '@api/api-service';

var VCA = VCA || {};

VCA.NewClientFirstExam = (function ($) {
    var ui = {};

    function cacheUI() {
        ui.$form = $('.nca-exam');
    }

    function init() {
        if ($('.nca-exam').length <= 0) {
            return;
        }
        cacheUI();
        bindFetchCouponClick();
    }


    function bindFetchCouponClick() {
        ui.$form.on('click', '.js-nca-exam-submit', function (e) {
            e.preventDefault();

            if (!checkform()) {
                return;
            } 
            else {
                postFormData();
            }

        });
    }

    function checkform() {
        var mailFormat = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
        var phoneReg = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        var textReg = /^[a-zA-Z -]{2,60}$/;
        var zipReg = /^(\d{5})(?:-?(\d{4}))?$/;
        
        let valid = true

        $('.nca-exam .form-wrapper input').each(function (index) {
            let el = $(this);
            var elmId = el.attr("id");
            if (elmId == 'phone') {
                let phone = $('#phone').val();
                if (!phoneReg.test(phone)) {
                    $('#phone').addClass('error');
                    $('#phone').closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    $('#phone').removeClass('error');
                    $('#phone').closest('.form-label-group').removeClass('error');
                }
            } else if (elmId == 'email') {
                let email = $('#email').val();
                if (!mailFormat.test(email)) {
                    $('#email').addClass('error');
                    $('#email').closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    $('#email').removeClass('error');
                    $('#email').closest('.form-label-group').removeClass('error');
                }
            }else if (elmId == 'zip') {
                let inputZip = el.val();
                if (!zipReg.test(inputZip)) {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                }
            }
             else {
                if (!textReg.test(el.val())) {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                }
            }
        });
        $('.js-client-form .select-box__select').each(function (index) {
            let el = $(this);
            if (el.val() == '' || el.val() == null) {
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
                var elmId = el.attr("id");
                requestInfo[elmId] = el.val();
            }
        });

        return valid;
    }


    async function postFormData() {


        const url = '/api/NCA/SubmitNCAForm';
        let api = new ApiService(url);
        var $firstName = ui.$form.find('#fname').val();
        var $lastName = ui.$form.find('#lname').val();
        var $email = ui.$form.find('#email').val();
        var $phone = ui.$form.find('#phone').val().replace(/[- ()\\s-]+/gi, "");
        var $zip = ui.$form.find('#zip').val();
        var $refUrl = document.referrer;
        var $currUrl = window.location.href;
        var redirect = ui.$form.find('#nca-redirectlink').val();
        var $hospitalsettingID = ui.$form.find('#hospital-settingId').val();
        var $hospitalsiteID = ui.$form.find('#hospital-siteId').val();
        let params = {
            "firstName": $firstName,
            "lastName": $lastName,
            "email": $email,
            "phone": $phone,
            "zip": $zip,
            "refUrl": $refUrl,
            "currUrl": $currUrl,
            "RedirectionUrl": redirect,
            "HospitaSettinglId": $hospitalsettingID,
            "HospitalSiteId": $hospitalsiteID
        }

        const {data,success,error} = await api.post(params);

        if (data.LeadId != '' && data.LeadId != null) {
            UpdateLeadTable(data.LeadId, data.CouponId);
            window.VCA.NCAOfferDataLayer.dataLayerNCAOfferSuccess();
        } else {
            ui.$form.find('#nca-errormessage').show();
        }

    }

    async function UpdateLeadTable(LeadId, CouponId) {

        var redirect = ui.$form.find('#nca-redirectlink').val();

        const url = '/api/NCA/UpdateLeadTable';
        let api = new ApiService(url);


        let params = {
            'leadId': LeadId
        }

        const {data,success,error} = await api.post(params);
        if (success && (data == true || data == 'True')) {
            window.location.assign(redirect + '?couponid=' + CouponId);
        } else {
            ui.$form.find('#nca-errormessage').show();
        }


    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.NewClientFirstExam.init();
});